import {
  EnumVideoBlockAspectRatio,
  EnumVideoBlockEmbedType,
} from '$/(cms)/_modules/cmsService/types';

export const getAspectPadding = (ratio?: EnumVideoBlockAspectRatio) => {
  if (ratio === EnumVideoBlockAspectRatio.Ratio_9_16) {
    return 177.78; // 9 / 16 * 100
  }

  return 56.25; // 16 / 9 default
};

export const extractYouTubeId = (raw?: string) => {
  if (!raw) return '';

  const url = raw.trim();
  const directIdMatch = /^[a-zA-Z0-9_-]{11}$/.test(url);
  if (directIdMatch) return url;

  try {
    const parsed = new URL(url);
    if (parsed.hostname === 'youtu.be') {
      return parsed.pathname.replace('/', '');
    }

    if (parsed.searchParams.get('v')) {
      return parsed.searchParams.get('v') ?? '';
    }

    const embedMatch = parsed.pathname.match(/\/embed\/([^/?]+)/);
    if (embedMatch?.[1]) {
      return embedMatch[1];
    }
  } catch (error) {
    return '';
  }

  return '';
};

export const getInstagramEmbedUrl = (raw?: string) => {
  if (!raw) return '';

  try {
    const parsed = new URL(raw.trim());
    const parts = parsed.pathname.split('/').filter(Boolean);
    const shortcodeIndex = parts.findIndex((p) =>
      ['p', 'reel', 'tv'].includes(p),
    );
    if (shortcodeIndex === -1) return '';

    const shortcode = parts[shortcodeIndex + 1];
    if (!shortcode) return '';

    return `https://www.instagram.com/${parts[shortcodeIndex]}/${shortcode}/embed`;
  } catch (error) {
    return '';
  }
};

export const isYouTubeEmbed = (
  embedType?: EnumVideoBlockEmbedType | null,
): embedType is EnumVideoBlockEmbedType.Youtube =>
  embedType === EnumVideoBlockEmbedType.Youtube;

export const isInstagramEmbed = (
  embedType?: EnumVideoBlockEmbedType | null,
): embedType is EnumVideoBlockEmbedType.Instagram =>
  embedType === EnumVideoBlockEmbedType.Instagram;
